<template>
<Card>
  <p slot="title"><Icon type="ios-apps" /> 权限体系管理</p>
  <Button type="success" icon="ios-add-circle" @click="showAddModule = true" slot="extra">添加模块</Button>
  <p>
    <div v-for="module in getModules()" :key="module.item">
      <Card >
        <p slot="title">{{ module.item }} ({{ module.note }})</p>
        <Button type="success" icon="ios-add-circle" @click="addItem(module)" slot="extra">新增子项</Button>
        <Button type="primary" icon="ios-create" @click="editModule(module)" slot="extra">修改模块</Button>
        <Row :gutter="16">
          <Col :span="12">
            <div class="auth-item-title">服务器端</div>
            <Col :span="8" v-for="model in groupItems(module.item, 2)" :key="model.id">
              <item :model="model" ref="module" @refresh="refresh"></item>
            </Col>
          </Col>
          <Col :span="12">
            <div class="auth-item-title">前端</div>
            <Col :span="8" v-for="model in groupItems(module.item, 1)" :key="model.id">
              <item :model="model" ref="module" @refresh="refresh"></item>
            </Col>
          </Col>
        </Row>
      </Card>
    </div>
  </p>

  <Modal v-model="showAddModule" title="添加模块" :footer-hide="true">
    <add-module ref="addModule" @refresh="refresh"></add-module>
  </Modal>
  <Modal v-model="showEditModule" title="修改模块" :footer-hide="true">
    <edit-module ref="editModule" @refresh="refresh"></edit-module>
  </Modal>
  <Modal v-model="showAddItem" title="新增子项" :footer-hide="true">
    <add-item ref="addItem" @refresh="refresh"></add-item>
  </Modal>
</Card>
</template>

<script>
import { ListItems } from '@/api/auth'
import AddModule from '@/components/auth/AddModule'
import EditModule from '@/components/auth/EditModule'
import AddItem from '@/components/auth/AddItem'
import Item from '@/components/auth/Item'

export default {
  name: 'list-auths',
  data: function () {
    return {
      modules: [],
      showAddModule: false,
      showEditModule: false,
      showAddItem: false
    }
  },
  components: {
    'add-module': AddModule,
    'edit-module': EditModule,
    'add-item': AddItem,
    item: Item
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function () {
      var query = this.$route.query
      ListItems(query).then(async res => {
        this.modules = res
      })
    },
    getModules: function () {
      return this.modules.filter(function (module) {
        return module.type === 0
      })
    },
    groupItems: function (id, type) {
      return this.modules.filter(function (module) {
        return module.parent_item === id && module.type === type
      })
    },
    editModule: function (module) {
      this.$refs.editModule.init(module)
      this.showEditModule = true
    },
    addItem: function (item) {
      this.$refs.addItem.init(item)
      this.showAddItem = true
    },
    refresh: function () {
      this.fetchData()
      this.showAddModule = false
      this.showEditModule = false
      this.showAddItem = false
    }
  }
}
</script>

<style>
.auth-item-title {
  font-weight: bold;
  padding: 5px 10px;
  border-bottom: 1px solid #d9dadb;
}
</style>
